import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "loader"]
  static values = { url: String }
  
  connect() {
    console.log("Subscriptions controller connected")
  }
  
  toggle(event) {
    this.showLoading()
    
    const checkbox = event.target
    const id = checkbox.id.substring(16)
    const category = checkbox.id.substring(0, 15)
    
    const formData = new FormData()
    formData.append('course_id', id)
    formData.append('category', category)
    formData.append('notify', checkbox.checked)
    
    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'text/plain'
      },
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.text()
    })
    .then(data => {
      this.statusTarget.innerHTML = data
      this.hideLoading()
    })
    .catch(error => {
      console.error('Error:', error)
      this.statusTarget.innerHTML = 'Error updating subscription'
      this.hideLoading()
    })
  }
  
  showLoading() {
    this.loaderTarget.classList.remove('d-none')
    this.loaderTarget.style.display = 'inline'
    this.statusTarget.innerHTML = 'saving...'
  }
  
  hideLoading() {
    this.loaderTarget.classList.add('d-none')
    this.loaderTarget.style.display = 'none'
  }
}